import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Button, Icon, Sidebar, Form } from 'semantic-ui-react';
import i18next from 'i18next';
import SideEditor from '../../general/SideEditor';
import { PhoneInput } from '../../common';
import {
    fetchSubscriptions,
    deleteSubscription,
    saveSubscription,
    confirmDelete,
    setEditedEntity,
    editEntityField,
} from '../../../actions';
import { getCurrentRestaurant } from '../../../selectors';

class Subscriptions extends Component {
    componentWillMount() {
        if (this.props.restaurant.id) {
            this.props.fetchSubscriptions(this.props.restaurant.id);
        }
    }

    handleDelete = (sub) => {
        this.props.confirmDelete(sub.description, () => this.props.deleteSubscription(this.props.restaurant.id, sub.id));
    }

    handleSubmit = (event) => {
        this.props.saveSubscription(this.props.restaurant.id, this.props.entity);
        event.preventDefault();
    }

    render() {
        const sub = this.props.entity || {};

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('addSubscription')}
                    visible={this.props.onEdit}
                    handleClose={() => this.props.setEditedEntity(null)}
                >
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Field>
                            <label>{i18next.t('description')}</label>
                            <input
                                placeholder={i18next.t('description')}
                                value={sub.description || ''}
                                onChange={({ target }) => this.props.editEntityField('description', target.value)}
                                required
                            />
                        </Form.Field>

                        <Form.Group inline>
                            <Form.Radio
                                label={i18next.t('email')}
                                checked={sub.type === 'email'}
                                onChange={() => {
                                    this.props.editEntityField('type', 'email');
                                    this.props.editEntityField('value', '');
                                }}
                            />
                            <Form.Radio
                                label={i18next.t('phone')}
                                checked={sub.type === 'phone'}
                                onChange={() => {
                                    this.props.editEntityField('type', 'phone');
                                    this.props.editEntityField('value', '');
                                }}
                            />
                        </Form.Group>

                        {sub.type === 'phone' ?
                            <Form.Field>
                                <PhoneInput
                                    value={sub.value}
                                    onChange={(phone) => this.props.editEntityField('value', phone)}
                                />
                            </Form.Field>
                            :
                            <Form.Field>
                                <input
                                    placeholder={i18next.t('email')}
                                    value={sub.value || ''}
                                    onChange={({ target }) => this.props.editEntityField('value', target.value)}
                                    required
                                />
                            </Form.Field>
                        }

                        <Button primary type='submit' floated="right">
                            {i18next.t('save')}
                        </Button>
                    </Form>
                </SideEditor>
                <div style={{ marginBottom: 10 }}>
                    <Button
                        icon
                        labelPosition='left'
                        primary
                        onClick={() => this.props.setEditedEntity('orderSubscription')}
                    >
                        <Icon name='add' /> {i18next.t('addSubscription')}
                    </Button>
                </div>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell singleLine>{i18next.t('description')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('type')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('value')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('actions')}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.orderSubscriptions.map((sub) => {
                            return (
                                <Table.Row key={sub.id}>
                                    <Table.Cell>{sub.description}</Table.Cell>
                                    <Table.Cell>{i18next.t(sub.type)}</Table.Cell>
                                    <Table.Cell>{sub.value}</Table.Cell>
                                    <Table.Cell collapsing>
                                        <Button circular size='tiny' icon='trash' negative onClick={() => this.handleDelete(sub)} />
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

Subscriptions.propTypes = {
    restaurant: PropTypes.object,
    fetchSubscriptions: PropTypes.func,
    orderSubscriptions: PropTypes.array,
    entity: PropTypes.object,
    editEntityField: PropTypes.func,
    setEditedEntity: PropTypes.func,
    saveSubscription: PropTypes.func,
    deleteSubscription: PropTypes.func,
    onEdit: PropTypes.bool,
    confirmDelete: PropTypes.func,
    
};

const mapStateToProps = (state) => {
    const { orderSubscriptions } = state.businessApp;
    const { entity, type } = state.editor;
    const onEdit = type === 'orderSubscription';
    const restaurant = getCurrentRestaurant(state);

    return { restaurant, entity, onEdit, orderSubscriptions };
};

export default connect(mapStateToProps, {
    fetchSubscriptions,
    deleteSubscription,
    saveSubscription,
    confirmDelete,
    setEditedEntity,
    editEntityField,
})(Subscriptions);
